import './style.scss';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.booom-text-tab-cards').forEach(function (section) {
        const allBtns   = section.querySelectorAll('.ttc-tab-btn');
        const allPanels = section.querySelectorAll('.ttc-panel');

        allBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                allBtns.forEach(function (b) {
                    b.classList.remove('is-active');
                    b.setAttribute('aria-selected', 'false');
                });

                btn.classList.add('is-active');
                btn.setAttribute('aria-selected', 'true');

                allPanels.forEach(function (p) { p.classList.remove('is-visible'); });

                const panel = document.getElementById(btn.dataset.panel);
                if (panel) panel.classList.add('is-visible');
            });
        });

        allPanels.forEach(function (panel) {
            const showAllWrap = panel.querySelector('.ttc-show-all-wrap');
            if (!showAllWrap) return;
            const showAllBtn = showAllWrap.querySelector('button');
            if (!showAllBtn) return;

            showAllBtn.addEventListener('click', function () {
                panel.querySelectorAll('.ttc-extra-card').forEach(function (card) {
                    card.classList.remove('hidden');
                });
                showAllWrap.remove();
            });
        });
    });
});
